/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ReactNode } from 'react';
import styled from '@emotion/styled';
import {
	FixedGrid,
	FixedGridItem,
	ContentWrap,
	ITheme,
	Css,
	Responsive,
	IUrlLinkItem,
} from '@/ui';
import { IFooterSocialLinksProps } from './FooterSocialLinks';
import { FooterLinkSection } from './FooterLinkSection';
import { IFooterLinkSections } from './types';
import { Color } from '../../../styles/Color';
import { FooterFinePrint } from './FooterFinePrint';
import FooterSocialsSection from './FooterSocialsSection';

export interface IFooterProps {
	linkSections: IFooterLinkSections;
	socialLinks: IFooterSocialLinksProps;
	finePrint: IUrlLinkItem[];
	children?: ReactNode;
}

export function Footer({ linkSections, socialLinks, finePrint }: IFooterProps) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');

	return (
		<StyledFooter>
			<ContentWrap>
				<StyledFixedGrid
					columns={[3, { tablet: 3, mobileXL: 2 }]}
					itemSelector={[FixedGridItem, FixedGridItem]}
				>
					{linkSections.map(({ key, ...props }) => (
						<FooterLinkSection key={key} {...props} />
					))}
					{!isMobileXL && <FooterSocialsSection socialLinks={socialLinks} />}
				</StyledFixedGrid>
			</ContentWrap>
			<FooterFinePrint socialLinks={socialLinks} links={finePrint} />
		</StyledFooter>
	);
}

export const StyledFooter = styled.footer<{}, ITheme>`
	padding-top: ${Css.pxToRemFromTheme(40)};
	width: 100%;
	border-top: ${Css.pxToRemFromTheme(1)} solid ${Color.Neutral94};
	position: relative;
	bottom: 0;

	li {
		margin-bottom: ${Css.pxToRemFromTheme(16)};
	}
`;

const StyledFixedGrid = styled(FixedGrid)`
	justify-content: space-between;
	flex-wrap: nowrap;
`;
